<template>
  <el-autocomplete ref="ac" popper-class="el-select-table"
    :value="value"
    :fetch-suggestions="refresh"
    :placeholder="placeholder"
    :size="size"
    @select="select"
    @input="input"
    :valueKey="labelField"
    style="width:100%"
  >
    <template slot-scope="{ item }" v-if="columns">
      <span v-for="col in columns" :key="col.prop" :title="item[col.prop]" :style="cellStyle">
        {{ item[col.prop] }}
      </span>
    </template>
  </el-autocomplete>
</template>

<script>
export default {
  model: {
    prop: "value",
    event: "changeVal",
  },
  props: {
    value: [Number, String, Array],
    labelField: String,
    url: String,
    placeholder: String,
    size: String,
    extraParam: Object,
    searchKey: {
      type: String,
      default: 'numberOrName'
    },
    selFirst: Boolean,

    columns: Array,
    panelWidth: [Number, String],
  },
  data: function() {
    return {
    }
  },
  methods: {
    changePanelWidth: function() {
      var dropDownList = this.$refs.ac.$children[1].$el
      dropDownList.style.width = this.panelWidth
    },
    changeValue: function(item){
        if(item){
          this.$emit("changeVal", item[this.labelField]);
          this.$emit("change", item);
        }
        else{
          this.$emit("changeVal", null);
          this.$emit("change", null);
        }
    },
    input: function(val){
        this.$emit("changeVal", val);
    },
    select: function(item) {
      this.changeValue(item);
    },
    refresh: function(query, cb) {
      var postData = { }
      postData[this.searchKey] = query
      Object.assign(postData, this.extraParam)

      return this.$httpPost(this.url, postData).then(res => {
        if (!res.isSuccess) {
          this.$message.error(res.message)
        }
        this.changePanelWidth()
        var items = res.datalist || [];
        if(cb) cb(items);
        return items;
      })
    },
  },
  mounted: function(){
    if(this.selFirst){
      this.refresh().then(items=>{
          if (items && items.length > 0) {
            this.changeSelItem(items[0]);
          }
      })
    }
  },
  watch: {
  },
  computed: {
    cellStyle: function(){
      var colCount = this.columns.length||1;
      return {
        width: `${100/colCount}%`
      }
    }
  }
}
</script>

<style lang="less">
  .el-select-table {
    span {
      display: inline-block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
</style>
